"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryCode = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../constants");
/**
 * Get country code from cookie and convert it to 'uk' if it is 'gb'.
 */
const getCountryCode = () => {
  const countryCode = _jsCookie.default.get(_constants.COUNTRY_CODE_COOKIE_NAME)?.toLocaleLowerCase();
  return countryCode === 'gb' ? 'uk' : countryCode;
};
exports.getCountryCode = getCountryCode;
